import React from "react";
import "./treatmentJourneyChrome.css";
import FlowContextHeader from "./FlowContextHeader";
import JourneyProgress from "./JourneyProgress";
import { presentationForRuntime } from "./runtimePresentation";

export default function TreatmentJourneyChrome({
  presentation,
  progressOverride = null,
}) {
  const runtime = presentationForRuntime(presentation);

  return (
    <div className="treatment-journey-chrome">
      <FlowContextHeader
        container={runtime.presentation.container}
      />
      <JourneyProgress
        progress={progressOverride || runtime.journey_presentation.progress}
        showTrack={false}
      />
    </div>
  );
}
